import { z } from 'zod';

import { FinancialAmountModel, TaxModel } from '@/finance';

export const BookingAddOnModel = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().default(''),
  priceContent: z.string().optional(),
  requestedQuantity: z.number().default(0),
  calculatedQuantity: z.number().default(0),
  cost: z.object({
    amountAfterTax: FinancialAmountModel,
    amountBeforeTax: FinancialAmountModel,
    amountSubtotalDisplay: FinancialAmountModel,
    taxesFees: z.object({
      amount: FinancialAmountModel.optional(),
      detail: z.array(TaxModel).default([]),
    }),
  }),
  displayType: z
    .enum([
      'ADD_ON_DISPLAY_TYPE_TOGGLE',
      'ADD_ON_DISPLAY_TYPE_ROCKER',
      'ADD_ON_DISPLAY_TYPE_UNKNOWN',
    ])
    .optional(),
  image: z
    .object({ url: z.string().optional(), altText: z.string().optional() })
    .optional(),
  controlLabel: z.string().optional(),
});

export type IBookingAddOnInstance = z.infer<typeof BookingAddOnModel>;
export type IBookingAddOnSnapshot = z.input<typeof BookingAddOnModel>;
